module.exports = __webpack_public_path__ + "static/media/pagination.2da337ef.svg";